<template>
  <div
      v-if="hasPicto || text"
      :class="[
      'd-flex py-05 px-1 justify-content-center align-items-center rounded-1 gmb-sticker',
      { 'gmb-sticker--alert': isAlert },
    ]"
  >
    <slot/>

    <FdText
        v-if="text"
        :class="{ 'ml-1': hasPicto }"
        colorWhite
        fontSizeSmaller2
        tag="span"
    >{{ text }}
    </FdText
    >
  </div>
</template>

<script>
import {hasEnrichedSlot} from "@/helpers.js";

import FdText from "@/flexdesign/Text";

export default {
  name: "GmbSticker",

  components: {
    FdText,
  },

  props: {
    text: [Number, String],
    isAlert: Boolean,
  },

  data() {
    return {};
  },

  computed: {
    hasPicto() {
      return hasEnrichedSlot(this, "default");
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";
@import "@/sass/settings/fonts";
@import "@/../node_modules/bootstrap/scss/functions";
@import "@/../node_modules/bootstrap/scss/mixins";
@import "@/../node_modules/bootstrap/scss/variables";
@import "@/../node_modules/bootstrap/scss/utilities/spacing";

/* =========================================================================
 * STICKER
 * ========================================================================= */

.gmb-sticker {
  max-width: 100%;
  background-color: $gmb-color-theme-2;
  font-family: $gmb-font-family-mono;

  &--alert {
    background-color: $gmb-color-alert !important;
  }
}
</style>
